import React from 'react';
import  GitaDharaClass6  from 'views/GitaDharaClass6';

const AccountGeneralPage = () => {
  return <GitaDharaClass6 />;
};

export default AccountGeneralPage;